/* PCN Portal Preview 
DO NOT USE THIS COMPONENT OR THE CUSTOM CLASS NAMES ON ANY OTHER PAGE
THIS IS A PREVIEW THAT LIVE CUSTOMERS GENERATE WHEN THEY CHANGE SETTINGS
CUSTOM CSS IS DECLARED IN App.css AND SHOULD BE TREATED AS EXCLUSIVE TO THIS COMPONENT
TO AVOID BREAKING UI
*/
import {Button} from 'react-bootstrap'

const ContentRow = ({children}) => {
    return (<div className="row px-3 px-md-0 pt-4 pb-4 mb-2">
        <div className="col-lg-3" />
        <div className="col-12 col-lg-9 px-0 px-md-3">
            {children}
        </div>
    </div>)
}

export function PcnPortalPreview({ themeColour, logoUrl, previewRef }) {

    return (
        <div id="pcn-portal-preview" className="pcn-preview-scaler">
        <div className='pcn-shell' ref={previewRef}>
            <div className="container-md">
                <header className="row pt-4 pb-4 mt-5 pcn-header">
                    <div className='col-12 col-md-6 col-lg-3 d-flex justify-content-center justify-content-md-start'>
                        { logoUrl && <img className="pcn-header__logo" src={ logoUrl } alt="Organisation logo" /> }
                    </div>
                    <div className='col-12 col-md-6 col-lg-9 d-flex justify-content-center justify-content-lg-start align-items-end'>
                        <div className="d-flex justify-content-center justify-content-md-start w-100">
                            <h1 className='mt-3 mt-md-0 mb-0 fw-lighter'>Manage your PCN</h1>
                        </div>
                    </div>
                </header>
                <hr className="section-divider m-0" />
                <main>
                    <ContentRow>
                        <p className="fw-lighter fs-4 m-0 mb-3 mb-md-4">Please provide details to start your process</p>
                        <form className="d-flex flex-column flex-md-row px-2 px-md-0">
                            <div className="d-flex flex-column align-items-center mr-4 mb-md-0">
                                <label className="fs-3 mb-2" htmlFor='reference-number'>Parking charge number<span className="text-danger">*</span></label>
                                <input
                                    readOnly
                                    id='reference-number'
                                    required
                                    type='text'
                                    value="ABC12345"
                                    className="form-control form-control-lg"
                                />
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                <label htmlFor='vrm' className="fs-3 mb-2">Vehicle registration mark<span className="text-danger">*</span></label>
                                <div className="d-flex">
                                    <div className="number-plate__strip" />
                                    <input
                                        readOnly
                                        id='vrm'
                                        type='text'
                                        value="XYZ678"                                            
                                        className="number-plate"
                                    />
                                </div>
                            </div>
                        </form>
                    </ContentRow>
                    <hr className="section-divider m-0" />
                    <ContentRow>
                        <div className='d-flex flex-column flex-md-row justify-content-md-start align-items-center gap-md-3 mt-3 mt-md-0'>
                            <div className='d-flex justify-content-center justify-content-md-start'>
                                <Button className='border-0 mr-3' style={{backgroundColor: themeColour}}>Clear</Button>
                                <Button className='btn border-success bg-success text-black'>Submit</Button>
                            </div>
                        </div>
                    </ContentRow>
                </main>
            </div>
            <div className="pcn-page-gradient" aria-hidden="true"></div>
            <footer className="pcn-footer position-relative z-1 w-100 flex-shrink-0" style={{backgroundColor: themeColour}}>
                <div className="pcn-footer__logo-placeholder bg-theme d-flex align-items-center justify-content-end text-white">
                    <p className="m-0 me-2">Powered by</p>
                    <img alt='APT logo' src="/assets/img/apt-logos/logo-white.svg" width="100px" />
                </div>
            </footer>
        </div>
        </div>
    )
}
